import { ErrorHandler, Injectable } from '@angular/core';

import { Logger } from './logger.service';

/**
 * Global Angular ErrorHandler that forwards uncaught errors to the
 * shared Logger (which in turn ships them to Datadog with the Error
 * object intact). Without this, async errors from observables/promises
 * are only caught by datadogLogs's window.onerror hook and lose context.
 */
@Injectable()
export class DatadogErrorHandler implements ErrorHandler {
  private readonly log = new Logger('UncaughtError');

  handleError(error: unknown): void {
    if (error instanceof Error) {
      this.log.error(error.message, error);
    } else {
      this.log.error('Non-Error thrown', String(error));
    }
  }
}
